// extracted by mini-css-extract-plugin
export default {"Contact":"Contact_Contact__Gf5+B","Title":"Contact_Title__oUalB","Body":"Contact_Body__sNUzz","Name":"Contact_Name__cjx7M","Email":"Contact_Email__XgicR"};